export default "https://cdn-static.gokick.com/assets/37f77ff38331b66adda42c842f0b505f9084d1fd/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";